<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2fm"><a id="page_5"><span class="txbf">INTRODUCTION</span></a></h2><a id="page_5">
<p class="noindent">Compared to other types of investments, real estate ranks as one of the most profitable, least risky, and most stable choices (but if part of the fun for you is rollercoaster-like risk, there are real estate investments for you too). No matter what’s going on in the world, people need a place to live and somewhere to work, and that means real estate will always be in demand, making it a perfect piece of every portfolio.</p>
<p class="indentb">When you hear the phrase <span class="txit">real estate investing</span>, the first thing to come to your mind may be renting properties to tenants. Or you may think of house flipping, something becoming increasingly popular. It’s true that these are types of real estate investing, but they’re far from the only ones. Among the kinds of real estate investing to choose from are:</p>
<p class="bull">• Real estate mutual funds</p>
<p class="bull">• Real estate investment trusts (REITs)</p>
<p class="bull">• Exchange-traded funds (ETFs)</p>
<p class="bullb">• Crowdfunded real estate</p>
<p class="indent">In this book, you’ll learn about all these and more. You’ll discover how to take advantage of special tax breaks, choose the most profitable properties, and even ways to start investing in real estate with as little as $50. With so many ways to get started, it’s easier than ever to begin building your own real estate empire—a proven path to accumulating serious wealth without taking on bank-breaking risk.</p>
</a><p class="indent"><a id="page_5"></a><a id="page_6">Whether you’re a novice in the art of real estate investing or you’ve had some experience and want to learn more, this book will be a reliable guide. You may want to become a full-time investor, flipping houses or managing properties. Or you may want to just dip your toes to make some money on the side. Either way, you need the advice offered in these pages.</a></p><a id="page_6">
<p class="indent">Welcome to <span class="txit">Real Estate Investing 101</span>.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?567c31da